// extracted by mini-css-extract-plugin
export default {"plainText":"SupplierCancelPalletsPickUpModal_plainText__tPBJD","boldBlackText":"SupplierCancelPalletsPickUpModal_boldBlackText__X7CyJ"};